import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationWamComponent } from "./authentication-wam.component";
import { AuthenticationWamService } from "./authentication-wam.service"

@Injectable()
export class AuthGuard implements CanActivate {
    
    constructor(private router: Router,
                private auth: AuthenticationWamComponent,
                private _authservice: AuthenticationWamService) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        //  debugger;
        let roles = route.data["roles"] as Array<string>;

        return new Promise((resolve, reject) => {
             //   .then(() => {
                    let userAuth = localStorage.getItem("userAuth");
                    if (userAuth === "true") {
                        localStorage.removeItem('state_url');
                        localStorage.setItem('state_url', state.url);
                        let userRoles: Array<string> = localStorage.getItem("userRoles").split(",");
                        resolve(this.isUserAllowed(roles, userRoles));
                    } else {
                       
                        resolve(false);
                    }
               // });
        });
    }

    isUserAllowed(allowedRoles: Array<string>, userRoles: Array<string>): boolean {
        for (var role of allowedRoles) {
            if (userRoles.indexOf(role) >= 0) {
                return true;
            }
        }
        this.router.navigate(['/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/authentication-wam/authguard.service.ts